"use strict";

jQuery(document).ready(function ($) {
  $('.product-category-selector__label').on('mouseover', function (e) {
    var category = $(this),
      catLabel = category.attr('data-label'),
      catImage = $('#' + catLabel);
    untoggleCategorySelector();
    category.addClass('active');
    catImage.addClass('active');
  });
  function untoggleCategorySelector() {
    $('.product-category-selector__label').each(function () {
      $(this).removeClass('active');
    });
    $('.product-category-selector__image').each(function () {
      $(this).removeClass('active');
    });
  }
});